import React from 'react';

import { scrollTop } from 'utils/wrappers';

import FulfillmentProducts from 'app/collections/fulfillment_products';
import FulfillmentInventoryReport from 'app/models/fulfillment_inventory_report';
import ApiModeSelection from 'app/models/api_mode_selection';
import Paginator from 'app/models/paginator';
import DateRange, { DATERANGE_PARAM_TYPES } from 'app/models/date_range';

import Base from 'app/views/base';
import PaginationView from 'app/views/pagination_view';
import SelectorView from 'app/views/selector_view';

import { List as ListView, Heading } from 'app/components/list/list';
import ListSearchView from 'app/components/list/search';
import { DetailBlock } from 'app/components/list/object_details';
import PageHeader from 'app/components/page_header_react';
import RequestReportView from 'app/components/request_report';

import tmpl from './template';

const PAGE_SIZE = 10;

function formatWarehouseInventory(inventory) {
  if (!inventory) { return ''; }
  return `${inventory.location.city}, ${inventory.location.state}: ${inventory.quantity}`;
}

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'fulfillment_products',

  initialize() {
    this.apiModeSelection = new ApiModeSelection({});
    this.collection = new FulfillmentProducts([], { apiModeSelection: this.apiModeSelection });
    this.dateRange = new DateRange({ paramType: DATERANGE_PARAM_TYPES.DATETIME });

    this.listenTo(this.collection, 'update', this.render);
    this.listenTo(this.collection, 'sync', this.render);
    this.listenTo(this.collection, 'sync', scrollTop);

    this.paginator = new Paginator({
      collection: this.collection,
      pageSize: PAGE_SIZE,
      buildParams() {
        return {
          limit: PAGE_SIZE,
          page: this.get('currentPage'),
          offset: this.get('currentPage') * PAGE_SIZE,
        };
      },
    });

    this.addReactComponent('header', <PageHeader name="Fulfillment Inventory" />);
    this.addSubview('requestReport', '#request_report', new RequestReportView({
      ReportClass: FulfillmentInventoryReport,
      dateRange: this.dateRange,
      apiModeSelection: this.apiModeSelection,
      maxDays: 0,
    }));

    this.addSubview('productList', '#product_list', new ListView({
      headings: [
        new Heading({
          property: 'title', display: 'Name', xsSize: 9, smSize: 8,
        }),
        new Heading({
          text: m => {
            if (this.collection.firstFetchSuccess) {
              return m.count();
            }
            return 'loading...';
          },
          display: 'Qty',
          xsSize: 3,
          smSize: 2,
        }),
      ],
      collection: this.collection,
      user: this.user,
      noResultsMessage: 'No products found matching your filter set.',
      showDetails: {
        mainHeading: m => m.get('id'),
        detailBlocks: [
          new DetailBlock({
            heading: 'Inventories',
            items: m => Object.keys(m.getInventory())
              .map(i => formatWarehouseInventory(m.getInventory(i))),
          }),
          new DetailBlock({
            heading: 'Size',
            items: m => [`${m.get('length').value} ${m.get('length').unit || ''} x ` +
            `${m.get('width').value} ${m.get('width').unit || ''}`],
          }),
          new DetailBlock({
            heading: 'Weight',
            items: m => [`${m.get('weight').value} ${m.get('weight').unit || ''}`],
          }),
          new DetailBlock({
            heading: 'Price',
            items: m => [`${m.get('price').value} ${m.get('price').unit || ''}`],
          }),
        ],
      },
    }));

    this.addSubview('pagination', '#product_pagination', new PaginationView({ model: this.paginator }));
    this.addSubview('apiModeSelector', '#api_mode_selector', new SelectorView({ model: this.apiModeSelection }));
    this.addSubview('search', '#product_search', new ListSearchView({
      collection: this.collection,
      placeholder: '(Product Id)',
      apiModeSelection: this.apiModeSelection,
    }));
  },

  context() {
    return {
      mode: this.apiModeSelection.getVal(),
    };
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/fulfillment_products/index.jsx